import * as R from 'ramda'

import i18n from '../../locales/i18n'
import { CountryCode } from '../../types'
import { LanguageCodes } from './languages'

const CountryNameMap = {
  [CountryCode.US]: {
    name: 'USA',
    nameTranslation: i18n.t('Regions:COUNTRIES.UNITED_STATES_OF_AMERICA'),
  },
  [CountryCode.CA]: {
    name: 'Canada',
    nameTranslation: i18n.t('Regions:COUNTRIES.CANADA'),
  },
  [CountryCode.ES]: {
    name: 'Spain',
    nameTranslation: i18n.t('Regions:COUNTRIES.SPAIN'),
  },
  [CountryCode.PT]: {
    name: 'Portugal',
    nameTranslation: i18n.t('Regions:COUNTRIES.PORTUGAL'),
  },
  [CountryCode.BR]: {
    name: 'Brazil',
    nameTranslation: i18n.t('Regions:COUNTRIES.BRAZIL'),
  },
}

// We'll be changing this in the future, to get those values from the BE in constants endpoint
const EnabledCountryCodesMap = {
  [CountryCode.US]: true,
  [CountryCode.CA]: true,
  [CountryCode.ES]: true,
  [CountryCode.PT]: false,
  [CountryCode.BR]: false,
}

export const CountryLanguagesCode = {
  [CountryCode.US]: LanguageCodes['en-US'],
  [CountryCode.CA]: LanguageCodes['en-US'],
  [CountryCode.ES]: LanguageCodes['es-ES'],
  [CountryCode.PT]: LanguageCodes['pt-PT'],
  [CountryCode.BR]: LanguageCodes['pt-BR'],
}

export const SupportedLngsCountriesCode = R.pipe(
  R.filter(R.equals(true)),
  R.keys,
)(EnabledCountryCodesMap) as CountryCode[]

const Countries = R.map(
  name => ({
    id: name,
    name: CountryNameMap[name]?.name || name,
    nameTranslation: CountryNameMap[name]?.nameTranslation || name,
  }),
  SupportedLngsCountriesCode,
)

export default Countries
